import Lottie, { LottieRefCurrentProps } from 'lottie-react'
import teams_page_one from '@/public/animations/teams_page_one.json'
import { useIntersection } from '@/hooks/Intersection'
import { useEffect, useRef } from 'react'

export const TeamsAnimation: React.FC = () => {
  const ref = useRef(null)
  const lottieRef = useRef<LottieRefCurrentProps | null>(null)
  const isTeamsVisible = useIntersection(ref, {})

  useEffect(() => {
    if (isTeamsVisible) {
      lottieRef.current?.play()
    } else {
      lottieRef.current?.pause()
    }
  }, [isTeamsVisible])

  return (
    <div ref={ref}>
      <Lottie lottieRef={lottieRef} loop={true} autoplay={true} animationData={teams_page_one}/>
    </div>
  )
}
